/**
 * Converts `amount` between two currencies through the base currency of `rates`, where `rates[X]` is
 * how many units of X one unit of the base currency buys: 100 EUR in GBP with EUR=0.85, GBP=0.73 is
 * 100 / 0.85 * 0.73.
 *
 * Returns `amount` unchanged when the currencies match; throws when a rate is missing.
 */
export function convertWithRates(
  amount: number,
  fromCurrency: string,
  toCurrency: string,
  rates: Record<string, number> | undefined
): number {
  if (fromCurrency === toCurrency) return amount;
  if (!rates) throw new Error('Exchange rates not available');
  if (!rates[fromCurrency]) throw new Error(`Exchange rate not available for ${fromCurrency}`);
  if (!rates[toCurrency]) throw new Error(`Exchange rate not available for ${toCurrency}`);
  return (amount / rates[fromCurrency]) * rates[toCurrency];
}
